import{isReactElementOr as e}from"../ReactElementOr/ReactElementOr.js";import{isHtmlElementName as t}from"../HtmlElementName/HtmlElementName.js";var m=function(m){return e(m,t)};export{m as isReactOrHtmlElement};
//# sourceMappingURL=ReactOrHtmlElement.js.map
